/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import RemScan from "../../../components/CommisioningGrid/RemScan/RemScan";
import { selectedDeviceSelector } from "../../../store/api/devices/selectors";
import { useSelector } from "react-redux";
import { IFullDeviceDetails } from "../../../store/api/deviceConfig/types";
import GlobalTemplate from "../../../components/CommisioningGrid/Templates/GlobalTemplate";
import LocalBulkTemplate from "../../../components/CommisioningGrid/Templates/LocalBulkTemplate";
// import Upgrade from "../../../components/CommisioningGrid/Upgrade/Upgrade";

const Commissioning: React.FC = () => {
  const deviceDetail: IFullDeviceDetails = useSelector(selectedDeviceSelector);

  return (
    <div
      style={{
        minHeight: "300px",
        border: "1px solid var(--color-border)",
        borderRadius: "var(--radius)",
        padding: "18px",
        boxShadow: "var(--shadow-card)",
        backgroundColor: "var(--card)",
      }}
    >
      <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", width: "100%" }}>
        {/* <Upgrade /> */}
        <GlobalTemplate />
        <LocalBulkTemplate />
        {deviceDetail.nodeType === "SN" && <RemScan />}
      </div>
    </div>
  );
};

export default Commissioning;
